import { SidebarContent } from "./SidebarContent";

/**
 * CAM V2 desktop navigation: intentionally compact so the video wall remains
 * the visual priority. Mobile navigation is rendered as a drawer by AppShell.
 */
export function Sidebar() {
  return (
    <aside
      className="hidden md:flex w-16 shrink-0 border-r border-white/[0.06] bg-[#111114] flex-col"
      data-testid="app-sidebar"
    >
      <SidebarContent collapsed />
    </aside>
  );
}
